/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShareTargetDto { 
    id?: string;
    scope?: ShareTargetDto.ScopeEnum;
    targetId?: number;
    label?: string;
}
export namespace ShareTargetDto {
    export type ScopeEnum = 'GLOBAL' | 'USER' | 'ORGANISATION';
    export const ScopeEnum = {
        GLOBAL: 'GLOBAL' as ScopeEnum,
        USER: 'USER' as ScopeEnum,
        ORGANISATION: 'ORGANISATION' as ScopeEnum
    };
}